export default {
  default: '/',
  investments: '/investments',
  investmentDetails: '/investments/investmentsDetails',
  news: '#',
  aboutUs: '#',
  FAQ: '#',
  contactUs: '#',
  notifications: '/notifications'
  // investments: '/investments',
  // news: '/news',
  // aboutUs: '/aboutUs/aboutUs',
  // FAQ: '/FAQ',
  // contactUs: '/contactUs',
};
